export type SalutationCode = "H" | "F";

/** Map API / questionnaire values to canonical H / F for forms. */
export function normalizeSalutationCode(raw: unknown): SalutationCode {
    const s = String(raw ?? "").trim().toLowerCase();
    if (s === "f" || s === "frau" || s === "w" || s === "female") return "F";
    return "H";
}

export function formatSalutationLabel(
    raw: unknown,
    t: (key: string) => string,
): string {
    return normalizeSalutationCode(raw) === "F" ? t("form.frau") : t("form.herr");
}
